export default __webpack_public_path__ + "static/media/statements-offline.e9795331.png";